<template>
  <div class="label-button">
    <span class="label-button__label">{{
      effect.container ? "容器中位置" : "画布中位置"
    }}</span>
    <el-dropdown trigger="click" @command="handleMenuClick">
      <el-button class="label-button__btn position-editor-btn">
        <svg width="14" height="14" viewBox="0 0 1024 1024">
          <path fill="currentColor"
            d="M838.2464 464.896H323.584c-2.2528 0-4.096-1.8432-4.096-4.096v-148.2752c0-2.2528 1.8432-4.096 4.096-4.096h514.6624c2.2528 0 4.096 1.8432 4.096 4.096V460.8c0 2.2528-1.8432 4.096-4.096 4.096zM670.3104 713.3184H323.584c-2.2528 0-4.096-1.8432-4.096-4.096v-148.2752c0-2.2528 1.8432-4.096 4.096-4.096h346.5216c2.2528 0 4.096 1.8432 4.096 4.096v148.2752c0.2048 2.2528-1.6384 4.096-3.8912 4.096zM209.1008 871.0144c-15.1552 0-27.4432-12.288-27.4432-27.648V180.6336c0-15.1552 12.288-27.648 27.4432-27.648s27.4432 12.288 27.4432 27.648v662.7328c0.2048 15.1552-12.0832 27.648-27.4432 27.648z"
          />
        </svg>
        对齐
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="left">
          <div class="el-dropdown-item-content">
            <svg width="16" height="16" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="M838.2464 464.896H323.584c-2.2528 0-4.096-1.8432-4.096-4.096v-148.2752c0-2.2528 1.8432-4.096 4.096-4.096h514.6624c2.2528 0 4.096 1.8432 4.096 4.096V460.8c0 2.2528-1.8432 4.096-4.096 4.096zM670.3104 713.3184H323.584c-2.2528 0-4.096-1.8432-4.096-4.096v-148.2752c0-2.2528 1.8432-4.096 4.096-4.096h346.5216c2.2528 0 4.096 1.8432 4.096 4.096v148.2752c0.2048 2.2528-1.6384 4.096-3.8912 4.096zM209.1008 871.0144c-15.1552 0-27.4432-12.288-27.4432-27.648V180.6336c0-15.1552 12.288-27.648 27.4432-27.648s27.4432 12.288 27.4432 27.648v662.7328c0.2048 15.1552-12.0832 27.648-27.4432 27.648z"
              />
            </svg>
            左侧
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="center">
          <div class="el-dropdown-item-content">
            <svg width="16" height="16" viewBox="0 0 1024 1024">
              <path fill="currentColor"
                d="M756.660375 561.871457H541.232032v-97.290219h126.109381c18.190818 0 33.111377-14.716168 33.111377-33.111378v-99.538523c0-18.190818-14.716168-33.111377-33.111377-33.111377h-126.109381V161.264671c0-16.146906-13.081038-29.227944-29.227944-29.227944s-29.227944 13.081038-29.227944 29.227944v137.555289h-126.109382c-18.190818 0-33.111377 14.716168-33.111377 33.111377v99.538523c0 18.190818 14.716168 33.111377 33.111377 33.111378h126.109382v97.290219H267.3478c-18.190818 0-33.111377 14.716168-33.111377 33.111377v99.538523c0 18.190818 14.716168 33.111377 33.111377 33.111378h215.428344v135.102594c0 16.146906 13.081038 29.227944 29.227944 29.227944s29.227944-13.081038 29.227944-29.227944V727.632735h215.428343c18.190818 0 33.111377-14.716168 33.111377-33.111378v-99.538523c-0.204391-18.39521-14.920559-33.111377-33.111377-33.111377z"
              />
            </svg>
            水平居中
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="right">
          <div class="el-dropdown-item-content">
          <svg width="16" height="16" viewBox="0 0 1024 1024">
            <path fill="currentColor"
              d="M185.7536 559.104H700.416c2.2528 0 4.096 1.8432 4.096 4.096v148.2752c0 2.2528-1.8432 4.096-4.096 4.096H185.7536c-2.2528 0-4.096-1.8432-4.096-4.096V563.2c0-2.2528 1.8432-4.096 4.096-4.096zM353.6896 310.6816H700.416c2.2528 0 4.096 1.8432 4.096 4.096v148.2752c0 2.2528-1.8432 4.096-4.096 4.096H353.6896c-2.2528 0-4.096-1.8432-4.096-4.096v-148.2752c0-2.2528 1.8432-4.096 4.096-4.096zM814.8992 152.9856c15.1552 0 27.4432 12.288 27.4432 27.648v662.7328c0 15.1552-12.288 27.648-27.4432 27.648s-27.4432-12.288-27.4432-27.648V180.6336c-0.2048-15.1552 12.0832-27.648 27.4432-27.648z"
            />
          </svg>
          右侧
          </div>
        </el-dropdown-item>
        <el-dropdown-item divided command="top">
          <div class="el-dropdown-item-content">
          <svg width="16" height="16" viewBox="0 0 1024 1024">
            <path fill="currentColor"
              d="M559.104 838.2464V323.584c0-2.2528 1.8432-4.096 4.096-4.096h148.2752c2.2528 0 4.096 1.8432 4.096 4.096v514.6624c0 2.2528-1.8432 4.096-4.096 4.096H563.2c-2.2528 0-4.096-1.8432-4.096-4.096zM310.6816 670.3104V323.584c0-2.2528 1.8432-4.096 4.096-4.096h148.2752c2.2528 0 4.096 1.8432 4.096 4.096v346.5216c0 2.2528-1.8432 4.096-4.096 4.096h-148.2752c-2.2528 0.2048-4.096-1.6384-4.096-3.8912zM152.9856 209.1008c0-15.1552 12.288-27.4432 27.648-27.4432h662.7328c15.1552 0 27.648 12.288 27.648 27.4432s-12.288 27.4432-27.648 27.4432H180.6336c-15.1552 0.2048-27.648-12.0832-27.648-27.4432z"
            />
          </svg>
          顶部
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="middle">
          <div class="el-dropdown-item-content">
          <svg width="16" height="16" viewBox="0 0 1024 1024">
            <path fill="currentColor"
              d="M462.132631 756.656287V541.227944h97.290219v126.109381c0 18.190818 14.716168 33.111377 33.111378 33.111378h99.538522c18.190818 0 33.111377-14.716168 33.111378-33.111378v-126.109381h137.555289c16.146906 0 29.227944-13.081038 29.227944-29.227944s-13.081038-29.227944-29.227944-29.227944h-137.555289v-126.109381c0-18.190818-14.716168-33.111377-33.111378-33.111378h-99.538522c-18.190818 0-33.111377 14.716168-33.111378 33.111378v126.109381h-97.290219V267.343713c0-18.190818-14.716168-33.111377-33.111378-33.111378h-99.538522c-18.190818 0-33.111377 14.716168-33.111378 33.111378v215.428343H161.268758c-16.146906 0-29.227944 13.081038-29.227944 29.227944s13.081038 29.227944 29.227944 29.227944H296.371353v215.428343c0 18.190818 14.716168 33.111377 33.111378 33.111378h99.538522c18.39521-0.204391 33.111377-14.920559 33.111378-33.111378z"
            />
          </svg>
          竖直居中
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="bottom">
          <div class="el-dropdown-item-content">
          <svg width="16" height="16" viewBox="0 0 1024 1024">
            <path fill="currentColor"
              d="M464.896 185.7536V700.416c0 2.2528-1.8432 4.096-4.096 4.096h-148.2752c-2.2528 0-4.096-1.8432-4.096-4.096V185.7536c0-2.2528 1.8432-4.096 4.096-4.096H460.8c2.2528 0 4.096 1.8432 4.096 4.096zM713.3184 353.6896V700.416c0 2.2528-1.8432 4.096-4.096 4.096h-148.2752c-2.2528 0-4.096-1.8432-4.096-4.096V353.6896c0-2.2528 1.8432-4.096 4.096-4.096h148.2752c2.2528 0 4.096 1.8432 4.096 4.096zM871.0144 814.8992c0 15.1552-12.288 27.4432-27.648 27.4432H180.6336c-15.1552 0-27.648-12.288-27.648-27.4432s12.288-27.4432 27.648-27.4432h662.7328c15.1552-0.2048 27.648 12.0832 27.648 27.4432z"
            />
          </svg>
          底部
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-popover
      placement="bottom"
      width="170"
      trigger="click"
      popper-class="shimmed-dropdown">
      <div class="position-editor-overlay">
        <div
          class="position-editor-overlay__row"
          v-for="(row, i) in rows"
          :key="i"
        >
          <button
            type="button"
            class="position-editor-overlay__button"
            v-for="item in row"
            :key="item.h + item.v"
            @click="handleClick(item)"
          >
            <svg width="12" height="12" viewBox="-1 -1 2 2">
              <path fill="currentColor" :d="item.path" />
            </svg>
          </button>
        </div>
      </div>
      <el-button slot="reference" class="label-button__btn position-editor-btn">
        <svg
          width="12"
          height="12"
          viewBox="0 0 16 16"
          class="position-editor-grid-icon"
        >
          <path
            fill="currentColor"
            d="M0 0L0 4L4 4L4 0zM6 0L6 4L10 4L10 0zM12 0L12 4L16 4L16 0zM0 6L0 10L4 10L4 6zM6 6L6 10L10 10L10 6zM12 6L12 10L16 10L16 6zM0 12L0 16L4 16L4 12zM6 12L6 16L10 16L10 12zM12 12L12 16L16 16L16 12z"
          />
        </svg>
        快速定位
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { rotateRect } from '../../utils';
import '../base/LabelButton.vue?vue&type=style&index=0&lang=css';

const paths = {
  'center middle': 'M0 -0.5A0.5 0.5 0 0 0 0 0.5A0.5 0.5 0 0 0 0 -0.5z',
  'right middle': "M1 0L0 -1L-0.21213203435596423 -0.7878679656440357L0.4257359312880715 -0.15L-1 -0.15L-1 0.15L0.4257359312880715 0.15L-0.21213203435596423 0.7878679656440357L0 1z",
  'right bottom': "M0.7071067811865476 0.7071067811865475L0.7071067811865475 -0.7071067811865476L0.4071067811865474 -0.7071067811865475L0.40710678118654753 0.19497474683058325L-0.6010407640085654 -0.8131727983645296L-0.8131727983645297 -0.6010407640085653L0.19497474683058333 0.40710678118654753L-0.7071067811865475 0.4071067811865476L-0.7071067811865475 0.7071067811865476z",
  'center bottom': "M6.123233995736766e-17 1L1 -6.123233995736766e-17L0.7878679656440357 -0.21213203435596428L0.15000000000000002 0.4257359312880715L0.14999999999999994 -1L-0.15000000000000005 -1L-0.14999999999999997 0.4257359312880715L-0.7878679656440357 -0.21213203435596417L-1 6.123233995736766e-17z",
  'left bottom': "M-0.7071067811865475 0.7071067811865476L0.7071067811865476 0.7071067811865475L0.7071067811865475 0.4071067811865474L-0.19497474683058325 0.40710678118654753L0.8131727983645296 -0.6010407640085654L0.6010407640085653 -0.8131727983645297L-0.40710678118654753 0.19497474683058333L-0.4071067811865476 -0.7071067811865475L-0.7071067811865476 -0.7071067811865475z",
  'left middle': "M-1 1.2246467991473532e-16L1.2246467991473532e-16 1L0.2121320343559643 0.7878679656440357L-0.4257359312880715 0.15000000000000005L1 0.14999999999999988L1 -0.1500000000000001L-0.4257359312880715 -0.14999999999999994L0.21213203435596414 -0.7878679656440357L-1.2246467991473532e-16 -1z",
  'left top': "M-0.7071067811865477 -0.7071067811865475L-0.7071067811865475 0.7071067811865477L-0.4071067811865474 0.7071067811865477L-0.40710678118654764 -0.19497474683058325L0.6010407640085655 0.8131727983645296L0.8131727983645298 0.6010407640085653L-0.19497474683058338 -0.40710678118654753L0.7071067811865475 -0.4071067811865477L0.7071067811865475 -0.7071067811865477z",
  'center top': "M-1.8369701987210297e-16 -1L-1 1.8369701987210297e-16L-0.7878679656440357 0.21213203435596437L-0.15000000000000008 -0.4257359312880715L-0.1499999999999998 1L0.1500000000000002 1L0.1499999999999999 -0.4257359312880715L0.7878679656440357 0.2121320343559641L1 -1.8369701987210297e-16z",
  'right top': "M0.7071067811865474 -0.7071067811865477L-0.7071067811865477 -0.7071067811865474L-0.7071067811865476 -0.4071067811865473L0.1949747468305832 -0.4071067811865476L-0.8131727983645295 0.6010407640085655L-0.6010407640085652 0.8131727983645298L0.4071067811865475 -0.1949747468305834L0.40710678118654775 0.7071067811865474L0.7071067811865477 0.7071067811865474z"
};

export default {
  props: ['effect', 'noContent', 'containerSize'],
  data() {
    return {};
  },
  computed: {
    ...mapState(['screenRatio', 'effects']),
    screenWidth() {
      return 480 * this.screenRatio;
    },
    containerHeight() {
      if (this.containerSize) {
        return this.containerSize.height
      } else {
        return this.effect.container ? this.effects[this.effect.container].content.height : 480;
      }
    },
    containerWidth() {
      if (this.containerSize) {
        return this.containerSize.width
      } else {
        return this.effect.container ? this.effects[this.effect.container].content.width : this.screenWidth;
      }
    },
    rows() {
      return ['top', 'middle', 'bottom'].map(v => ['left', 'center', 'right'].map(h => {
        return {
          path: paths[[h, v].join(' ')],
          h,
          v
        }
      }))
    }
  },
  methods: {
    handleClick({ h, v }) {
      this.processAlign(h);
      this.processAlign(v);
    },
    handleMenuClick(command) {
      this.processAlign(command);
    },
    processAlign(key) {
      const efc = this.noContent ? this.effect : this.effect.content
      const rotated = rotateRect(efc);
      switch (key) {
        case 'top': {
          const rotatedTop = Math.min.apply(Math, rotated.map(p => p.y));
          efc.top = Math.round(efc.top - rotatedTop);
          break;
        }
        case 'middle':
          efc.top = Math.round((this.containerHeight - efc.height) / 2);
          break;
        case 'bottom': {
          const rotatedBottom = Math.max.apply(Math, rotated.map(p => p.y));
          efc.top = Math.round(efc.top + this.containerHeight - rotatedBottom);
          break;
        }
        case 'left': {
          const rotatedLeft = Math.min.apply(Math, rotated.map(p => p.x));
          efc.left = Math.round(efc.left - rotatedLeft);
          break;
        }
        case 'center':
          efc.left = Math.round((this.containerWidth - efc.width) / 2);
          break;
        case 'right': {
          const rotatedRight = Math.max.apply(Math, rotated.map(p => p.x));
          efc.left = Math.round(efc.left + this.containerWidth - rotatedRight);
          break;
        }
      }
    }
  }
}
</script>
<style>
.position-editor-btn {
  margin-left: 6px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  font-size: 12px;
}
.position-editor-btn span, .el-dropdown-item-content {
  display: flex;
  align-items: center;
}
.position-editor-grid-icon {
  margin-right: 4px;
}

.position-editor-btn .anticon {
  font-size: 14px;
}

.position-editor-btn .anticon + span {
  margin-left: 4px;
}

.position-editor-overlay {
  background: #fff;
  width: 144px;
  padding: 12px 8px 8px 12px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.06);
}

.position-editor-overlay__row {
  display: flex;
  margin-bottom: 4px;
}

.position-editor-overlay__button {
  flex-grow: 1;
  height: 28px;
  margin-right: 4px;
  border: 0;
  border-radius: 0;
  background: #eee;
  outline: 0;
  color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.position-editor-overlay__button:hover,
.position-editor-overlay__button:focus {
  color: #fff;
  background: #007eff;
}

.timeline-filter-menu .ant-dropdown-menu-item>.anticon:first-child {
  font-size: 100%;
}

.timeline-filter-menu .ant-dropdown-menu-item>a>.anticon:first-child {
  margin-right: 8px;
  font-size: 100%;
}
</style>